import axios from 'axios';
import {jwtDecode} from 'jwt-decode';
import { encryptAES, decryptAES } from "./cryptoUtils";
import { getApgJWT } from './getApgJWT'

const BASE_URL = process.env.REACT_APP_API_BASE_URLE;

// ✅ Custom axios instance
const apiClient3 = axios.create({
 baseURL: BASE_URL,
 headers: {
   'Content-Type': 'application/json',
 },
 withCredentials: false,
});
// ✅ REQUEST INTERCEPTOR
apiClient3.interceptors.request.use(async (config) => {
const user_id = localStorage.getItem('user_id'); 
 
 
    try{
      const token = await getApgJWT();
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (err) {
      console.error('Error fetching apg jwt token:', err);
    }

 if (config.method === 'post' && config.data) {
   const plainString = JSON.stringify(config.data);

   const encryptedPayload = encryptAES(plainString);
   config.data = { encryptedRequest: encryptedPayload };
 }
 return config;
}, (error) => Promise.reject(error));
// ✅ RESPONSE INTERCEPTOR
// RESPONSE INTERCEPTOR (simple + safe)
apiClient3.interceptors.response.use(
  (response) => {
    // 1) Pick token from body
    const token = response.data?.token;
    if (token) {
      localStorage.setItem("app_jwt", token);
      // 2) Decode only if it's a real JWT
      if (token.split(".").length === 3) {
        try {
          const decoded = jwtDecode(token);
          if (decoded?.exp) {
            localStorage.setItem("app_jwt_expiry", decoded.exp * 1000);
          }
        } catch (err) {
          console.warn("JWT decode skipped (invalid/opaque token):", err);
        }
      } else {
        // Apigee opaque tokens, skip decode
        console.warn("Token is not a standard JWT, skipping decode:", token);
      }
    }
    // 3) Decrypt wrapped responses (if any)
    if (response.data?.encryptedResponse) {
      try {
        const decrypted = decryptAES(response.data.encryptedResponse);
        response.data = JSON.parse(decrypted);
      } catch (err) {
        console.error("Response decrypt error:", err);
      }
    }
    return response;
  },
  (error) => Promise.reject(error)
 );

export const generateKey = async (userId) => {
  const res = await apiClient3.post(`${BASE_URL}/biu-nova/nova/generate/key`, { user_id: userId });
  return res.data.key; // "<encUser>|<encKey>"
 };
 // Send the combined key back to link USERID to KEY_VALUE
 export const updateUserIdSSO = async (combinedKey,agentId, user_type) => {
    console.log("this is the request",{ key: combinedKey.split('|')[1], userId:agentId, userType: user_type })
  const res = await apiClient3.post(`${BASE_URL}/biu-nova/liva/sso-jwt`, { key: combinedKey.split('|')[1], userId:agentId, userType: user_type });
  return res.data; 
 };
 
export default apiClient3;

